import { GiftIcon } from "@xola/icons";
import { Currency } from "@xola/ui-kit";
import clsx from "clsx";
import { getGiftApplicablePurchaseItem } from "common/src/models/PurchaseItem";
import React from "react";
import { useHistory } from "react-router-dom";
import { Audit, ExperiencePurchaseItem, LineItem, LineItemObject, Purchase, PurchaseItem } from "types";
import { ExperienceTile } from "../ExperienceTile";
import { TimelineItem, TimelinePill } from "../TimelineItem";
import { usePurchase } from "@/hooks/resources/usePurchase";
import { useSeller } from "@/hooks/useAccount";

interface RedeemLineItemProps {
    change: LineItem;
}

export const RedeemLineItem = ({ change: lineItem }: RedeemLineItemProps) => {
    const seller = useSeller();
    const history = useHistory();
    const title = lineItem.amount < 0 ? "Redeemed" : "Removed";
    const { purchase } = usePurchase(lineItem.purchase?.id);
    const item = purchase?.items ? getGiftApplicablePurchaseItem(purchase?.items) : null;
    const handlePurchaseClick = () => {
        if (purchase) {
            history.push(`/purchases/${purchase.id}`);
        }
    };

    return (
        <TimelineItem title={title} icon={<GiftIcon />} color="primary" audit={lineItem}>
            <div className="flex flex-col space-y-2">
                <div className="flex flex-row space-x-2">
                    <Currency currency={seller.currency} shouldRemoveTrailingZeroes={false}>
                        {Math.abs(lineItem.amount)}
                    </Currency>
                </div>
                <span className={clsx("flex items-center", "hover:cursor-pointer")} onClick={handlePurchaseClick}>
                    <TimelinePill>
                        {item && (
                            <ExperienceTile
                                item={item}
                                experienceId={item.product.id}
                                arrivalDateTime={(item as ExperiencePurchaseItem).arrivalDateTime}
                            />
                        )}
                    </TimelinePill>
                </span>
            </div>
        </TimelineItem>
    );
};

RedeemLineItem.supportsAudit = (
    _purchase: Purchase,
    _item: PurchaseItem,
    _audit: Audit,
    _lineItem: PurchaseItem,
    _timezoneName: string,
    change: LineItem,
) => {
    return change.object === LineItemObject.COUPON_REDEEM;
};
